/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBankImport = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.447 1.106a1 1 0 0 0-.894 0l-10 5A1 1 0 0 0 2 8h20a1 1 0 0 0 .447-1.894zM12 3.118 17.764 6H6.236zM3 10v9h2v-9zm4 0v9h2v-9zm4 0v3h2v-3zm4 0v1h2v-1zm4 0v1h2v-1zM1 21v2h8v-2zm19.705-3a3 3 0 1 0-6 0v.586l1.293-1.293 1.414 1.414-3.707 3.707-3.707-3.707 1.414-1.414 1.293 1.293V18a5 5 0 1 1 5 5v-2a3 3 0 0 0 3-3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBankImport as BankImport };
